import { h } from 'preact';
import { Router } from 'preact-router';

import Header from './header';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import LogIn from '../routes/logIn';
import RegisterClub from '../routes/register-club';
import Coupon from '../routes/coupon';
import CreateCoupon from '../routes/create-coupon';
import ManageClub from '../routes/manage-club';
import ChangePass from '../routes/change-pass';
import UpdateAvatar from '../routes/update-avatar';
import Referral from '../routes/referral';
import AddDistricts from '../routes/add-districts';
import MindbodyOnboarding from '../routes/mindbody-onboarding';
import MomenceOnboarding from '../routes/momence-onboarding';
import Applications from '../routes/applications';
import Credentials from '../routes/credentials';
import ReferralTiers from '../routes/referral-tiers';
import RewardRules from '../routes/reward-rules';
import InvitationCodes from '../routes/invitation-codes';
import UserReferralCodes from '../routes/user-referral-codes';
import PointsInspection from '../routes/points-inspection';
import TrainerSuspension from '../routes/trainer-suspension';
import ManageBanners from '../routes/manage-banners';
import ManageAppVersion from '../routes/manage-app-version';
import ManageCouponPolicyRedirect from '../routes/manage-coupon-policy-redirect';
import ManageApplications from '../routes/manage-applications';
import DeleteUser from '../routes/delete-user';
import InvitationQuota from '../routes/invitation-quota';
import RunScripts from '../routes/run-scripts';
import EditUser from '../routes/edit-user';

const App = () => (
	<div id="app">
		<Header />
		<main>
			<Router>
				<Home path="/" />
				<LogIn path="/login" />
				<RegisterClub path="/register-club" />
				<Coupon path="/coupon" />
				<CreateCoupon path="/create-coupon" />
				<ManageClub path="/manage-club" />
				<ChangePass path="/change-pass" />
				<UpdateAvatar path="/update-avatar" />
				<Referral path="/referral" />
				<AddDistricts path="/add-districts" />
				<MindbodyOnboarding path="/mindbody-onboarding" />
				<MomenceOnboarding path="/momence-onboarding" />
				<Applications path="/applications" />
				<Credentials path="/credentials" />
				<ReferralTiers path="/referral-tiers" />
				<RewardRules path="/reward-rules" />
				<InvitationCodes path="/invitation-codes" />
				<UserReferralCodes path="/user-referral-codes" />
				<PointsInspection path="/points-inspection" />
				<TrainerSuspension path="/trainer-suspension" />
				<ManageBanners path="/manage-banners" />
				<ManageAppVersion path="/manage-app-version" />
				<ManageCouponPolicyRedirect path="/manage-coupon-policy" />
				<ManageApplications path="/manage-applications" />
				<DeleteUser path="/delete-user" />
				<InvitationQuota path="/invitation-quota" />
				<RunScripts path="/run-scripts" />
				<EditUser path="/edit-user" />
			</Router>
		</main>
	</div>
);

export default App;
